var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuRegionsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#435382",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.5C18.75 8.40537 18.4565 9.66977 17.9391 11.102C17.4274 12.5186 16.7187 14.0398 15.9388 15.4379C15.1571 16.8392 14.3176 18.0927 13.552 18.9846C13.1681 19.4319 12.8201 19.7678 12.5239 19.9856C12.2089 20.2173 12.041 20.25 12 20.25C11.959 20.25 11.7911 20.2173 11.4761 19.9856C11.1799 19.7678 10.8319 19.4319 10.448 18.9846C9.68243 18.0927 8.84287 16.8392 8.06124 15.4379C7.28135 14.0398 6.57261 12.5186 6.06085 11.102C5.54346 9.66977 5.25 8.40537 5.25 7.5C5.25 3.77208 8.27208 0.75 12 0.75C15.7279 0.75 18.75 3.77208 18.75 7.5Z",
    stroke: "current",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: 2.25,
    stroke: "current",
    strokeWidth: 1.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 20.25C6.75 20.25 7.5 23.25 12 23.25C16.5 23.25 17.25 20.25 17.25 20.25",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRegionsIcon);
export default __webpack_public_path__ + "static/media/menu-regions-icon.54850bee54f3b4be5da9e29c6bb3c5ca.svg";
export { ForwardRef as ReactComponent };